import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_NOTIFICATION = createActionTypes('FETCH_NOTIFICATION');
export const DELETE_NOTIFICATION = createActionTypes('DELETE_NOTIFICATION');
export const UPDATE_FIRMWARE_NOTIFICATION = createActionTypes('UPDATE_FIRMWARE_NOTIFICATION');
export const NOTIFICATION = createActionTypes('NOTIFICATION');
export const REMOVE_NOTIFICATION = createActionTypes('REMOVE_NOTIFICATION');
export const PUSH_NOTIFICATION = createActionTypes('PUSH_NOTIFICATION');
